var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-404"},[_c('div',{staticClass:"error-404__message"},[_vm._v("404エラーが発生しました。")]),_c('a',{staticClass:"error-404__link",attrs:{"href":_vm.returnPage}},[_vm._v("戻る")])])
}
var staticRenderFns = []

export { render, staticRenderFns }